import { Settings } from "luxon";
import { DropdownV2 } from "@/ui/dropdown/dropdown-v2";
import { DynamicFormElement } from "@/ui/dynamic-form/dynamic-form";
import { InputCaptchaElement } from "@/ui/input-captcha/input-captcha";
import { InputV3 } from "@/ui/input/input-v3";
import { ManualScroll } from "@/ui/manual-scroll/manual-scroll";
import { SelectV2 } from "@/ui/select/select-v2";
import { createTooltip } from "@/ui/tooltip/create-tooltip";
import { createCookieConsent } from "@/components/cookie-consent/cookie-consent";
import { createHeader } from "@/components/header/header";
import { createModuleFeedback } from "@/components/module-feedback/module-feedback";
import { createMixpanel } from "@/utils/mixpanel";
import { createSentryTracing } from "@/utils/sentry";

export const createLayout = () => {
  createCookieConsent();
  createSentryTracing();
  createHeader();
  createTooltip();
  createModuleFeedback();
  createMixpanel();

  if (window.userTimezone !== undefined) {
    Settings.defaultZone = window.userTimezone;
  }

  Settings.defaultLocale = document.documentElement.lang;

  window.customElements.define("input-v3", InputV3);
  window.customElements.define("dropdown-v2", DropdownV2);
  window.customElements.define("select-v2", SelectV2);
  window.customElements.define("manual-scroll", ManualScroll);
  window.customElements.define("input-captcha", InputCaptchaElement);
  window.customElements.define("dynamic-form", DynamicFormElement);
};
